module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-12.06434cc6.png";